import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatPrice } from "../../helpers/formattedPrice";
import animationImg from "../../assets/images/invoice-animation.gif";

const CombinedInvoice = ({
  item,
  payload,
  totalPurchasePrice,
  walletDeduction,
  priceAfterWallet,
  receivingAmount,
  managementFeesPercent,
  managementFee,
  finalAmount,
  showWalletRows,
  currency,
  isSubmitting,
  onBack,
  onSubmit,
}) => {
  const { dir } = useSelector((state) => state.language);
  const { t } = useTranslation();

  return (
    <div dir={dir} className="invoice buy-and-supply-2026__invoice">
      <div className="invoice__animation-holder mx-auto">
        <img
          src={animationImg}
          alt=""
          className="d-block img-fluid"
          loading="lazy"
        />
      </div>
      <h1 className="text-center fsize-8 fw-bold">{t("invoice.invoice")}</h1>
      <div className="px-md-4 px-lg-1 px-xl-5">
        <div className="invoice__data-holder">
          <ul className="m-0 p-0 list-unstyled d-flex flex-column gap-4">
            <li className="d-flex align-items-center justify-content-between gap-2">
              <span className="invoice__data-holder__title fsize-9">
                {t("invoice.itemName")}
              </span>
              <span className="invoice__data-holder__value fsize-11">
                {item?.itemName || item?.description}
              </span>
            </li>
            <li className="d-flex align-items-center justify-content-between gap-2">
              <span className="invoice__data-holder__title fsize-9">
                {t("invoice.itemType")}
              </span>
              <span className="invoice__data-holder__value fsize-11">
                {item?.categoryName || item?.category}
              </span>
            </li>
            <li className="d-flex align-items-center justify-content-between gap-2">
              <span className="invoice__data-holder__title fsize-9">
                {t("invoice.paymentMethod")}
              </span>
              <span className="invoice__data-holder__value fsize-11">
                {payload?.paymentTypeName}
              </span>
            </li>
            <li className="d-flex align-items-center justify-content-between gap-2">
              <span className="invoice__data-holder__title fsize-9">
                {t("invoice.quantity")}
              </span>
              <span className="invoice__data-holder__value fsize-11">
                {payload?.quantity}
              </span>
            </li>
            <li className="d-flex align-items-center justify-content-between gap-2">
              <span className="invoice__data-holder__title fsize-9">
                {t("invoice.unitPrice")}
              </span>
              <span className="invoice__data-holder__value fsize-11">
                {formatPrice?.(item?.pricePerKilo)} {currency}
              </span>
            </li>

            <li className="d-flex align-items-center justify-content-between gap-2">
              <span className="invoice__data-holder__title fsize-9 fw-bold">
                {t("invoice.totalPrice")}
              </span>
              <span className="invoice__data-holder__value--total-price fw-bold fsize-11">
                {formatPrice?.(totalPurchasePrice)} {currency}
              </span>
            </li>

            {showWalletRows && (
              <>
                <li className="d-flex align-items-center justify-content-between gap-2">
                  <span className="invoice__data-holder__title fsize-9 fw-bold">
                    {t("buyAndSupply2026.walletDeduction")}
                  </span>
                  <span className="invoice__data-holder__value--total-price fw-bold fsize-11">
                    {formatPrice?.(walletDeduction)} {currency}
                  </span>
                </li>
                <li className="d-flex align-items-center justify-content-between gap-2">
                  <span className="invoice__data-holder__title fsize-9 fw-bold">
                    {t("buyAndSupply2026.priceAfterWalletDeduction")}
                  </span>
                  <span className="invoice__data-holder__value--total-price fw-bold fsize-11">
                    {formatPrice?.(priceAfterWallet)} {currency}
                  </span>
                </li>
              </>
            )}

            <li className="d-flex align-items-center justify-content-between gap-2">
              <span className="invoice__data-holder__title fsize-9 fw-bold">
                {t("buyAndSupply2026.receivingAmount")}{" "}
                <span className="buy-and-supply-2026__modal__summary-note fw-normal">
                  {t("buyAndSupply2026.receivingAmountPeriod")}
                </span>
              </span>
              <span className="invoice__data-holder__value--total-price fw-bold fsize-11">
                {formatPrice?.(receivingAmount)} {currency}
              </span>
            </li>

            <li className="d-flex align-items-center justify-content-between gap-2 buy-and-supply-2026__invoice__fee">
              <span className="fsize-11">
                *{t("buyAndSupply2026.managementFee")} ({managementFeesPercent}
                %):
              </span>
              <span className="fsize-11">
                {formatPrice?.(managementFee)} {currency}
              </span>
            </li>

            <li className="d-flex align-items-center justify-content-between gap-2">
              <span className="invoice__data-holder__title fsize-9 fw-bold">
                {t("buyAndSupply2026.finalAmount")}
              </span>
              <span className="invoice__data-holder__value--total-price fw-bold fsize-11">
                {formatPrice?.(finalAmount)} {currency}
              </span>
            </li>
          </ul>
        </div>

        <div className="row m-0">
          <div
            className={`col-6 ${
              dir === "ltr" ? "ps-0 pe-3 pe-lg-4" : "pe-0 ps-3 ps-lg-4"
            }`}
          >
            <Button
              onClick={onBack}
              className="invoice__btn invoice__btn--back w-100 fsize-5 border-0 fw-bold h-auto d-block text-white"
            >
              {t("invoice.back")}
            </Button>
          </div>
          <div className="col-6 px-0">
            <Button
              onClick={onSubmit}
              loading={isSubmitting}
              className="invoice__btn invoice__btn--submit w-100 fsize-5 border-0 fw-bold h-auto d-block text-white"
            >
              {t(
                `invoice.${
                  payload?.paymentTypeId === 1 ||
                  payload?.paymentTypeId === 9 ||
                  payload?.paymentTypeId === 0
                    ? "buyItem"
                    : "proceedToCheckout"
                }`,
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CombinedInvoice;
